import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { label: '今日准点', href: '#hero' },
  { label: '大图流', href: '#feed' },
  { label: '时间线', href: '#timeline' },
  { label: '热评', href: '#comments' },
  { label: '吃瓜热榜', href: '#ranking' },
  { label: '准点提醒', href: '#subscribe' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1360px] items-center gap-4 px-4 md:px-6">
        <a href="#hero" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-time-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-lg font-black tracking-tight text-foreground-950">
              黑料六点
            </h1>
            <span className="mt-0.5 text-[10px] font-medium tracking-[0.18em] text-primary-600">
              每日 18:00 准点
            </span>
          </span>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <label className="hidden h-9 items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-500 xl:flex">
            <i className="ri-search-line text-base" />
            <input
              type="text"
              placeholder="搜关键词 / 时间点"
              className="w-40 bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </label>
          <a
            href="#subscribe"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-notification-3-line text-base" />
            预约准点
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto grid w-full max-w-[1360px] grid-cols-2 gap-1 px-4 py-3 md:px-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}